import API from 'services/TAPS_API';

export default function checkExistingOktmo(code) {
  return API.request({
    method: 'GET',
    url: `/dictionary/okato-oktmo?code=${code}`,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
